
class HCOriginalPriceQV{
  constructor(settings){
    this.domain = settings["domain"];
    this.selector = ".theme-modal--inner form[action*='/cart/add']";
    this.variants = settings.variants || [];
    this.original_price_label = settings.original_price_label || "Original price";    
    this.input_class = "hc_original_price_prop";
    this.money_format = settings.money_format || "{{amount}}";
    this.visibility = settings.visibility || "all";
  }
  
  getPropertyName(){
    // If visibility is "admin", prefix with underscore to hide from customers
    return this.visibility === "admin" ? `_${this.original_price_label}` : this.original_price_label;
  }

  decodeHTMLEntities(text) {
    const el = document.createElement('textarea');
    el.innerHTML = text;
    return el.value;
  }

  formatMoney(cents){
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = this.money_format;

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
        case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
        case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
        case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return this.decodeHTMLEntities(formatString.replace(placeholderRegex, value));
  }

  removeOriginalPriceInput(){
    const inputs = document.querySelectorAll(`.${this.input_class}`);
    if (inputs.length > 0){
      inputs.forEach(input => {
        input.remove();
      });
    }
  }
  
  manageOriginalPriceInput(selectedVariant){
    if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
      // Compare at price is higher, add or update inputs
      const forms = document.querySelectorAll(this.selector);
      console.log(forms)
      if (forms.length > 0){
        forms.forEach(form => {
          const existingInput = form.querySelector(`.${this.input_class}`);
          if (existingInput) {
            // Update existing input value
            existingInput.value = this.formatMoney(selectedVariant.compare_at_price);
          } else {
            // Create new input
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = `properties[${this.getPropertyName()}]`;
            input.value = this.formatMoney(selectedVariant.compare_at_price);
            input.classList.add(this.input_class);
            form.appendChild(input);
          }
        });
      }
    } else {
      // Compare at price is not higher, remove inputs
      this.removeOriginalPriceInput();
    }
  }


  initProductPage(){
    this.manageOriginalPriceInput();
  }

  
  init(){
    // (document.readyState === "complete" || document.readyState === "loaded")
    
      // product page sale label
        this.initProductPage();
  }
}
    if (hcOriginalPriceSettingsQV){
        var hcOriginalPriceQV = new HCOriginalPriceQV(hcOriginalPriceSettingsQV);
        window.hcOriginalPriceQV = hcOriginalPriceQV;
        console.log( window.hcOriginalPriceQV)
    }
